import React, { useState } from "react";
import { ComponentRenderer } from "../components/ComponentRenderer";
import { screen_102_add_vehicle } from "../config/102_add_vehicle";

export const FormDemo: React.FC = () => {
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [actionLog, setActionLog] = useState<string[]>([]);

  const handleFormDataChange = (name: string, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Log the change
    const logEntry = `Field "${name}" changed to: ${JSON.stringify(value)}`;
    setActionLog((prev) => [...prev.slice(-9), logEntry]); // Keep last 10 entries
  };

  const handleActionTrigger = (actionId: string, data?: any) => {
    const logEntry = `Action triggered: ${actionId}${
      data ? ` with data: ${JSON.stringify(data)}` : ""
    }`;
    setActionLog((prev) => [...prev.slice(-9), logEntry]);

    // Handle specific actions
    switch (actionId) {
      case "submit_registration":
        alert("Registration submitted! Check the console for form data.");
        console.log("Registration Data:", formData);
        break;
      case "save_draft":
        alert("Draft saved!");
        break;
      case "cancel_form":
        if (
          confirm("Are you sure you want to cancel? All data will be lost.")
        ) {
          setFormData({});
          setActionLog([]);
        }
        break;
      case "reset_form":
        if (confirm("Are you sure you want to reset the form?")) {
          setFormData({});
          setActionLog([]);
        }
        break;
      case "search_cities":
        console.log("Searching cities for:", data?.searchTerm);
        break;
      case "search_countries":
        console.log("Searching countries for:", data?.searchTerm);
        break;
      case "upload_profile_photo":
        console.log("Profile photo uploaded:", data?.files);
        break;
      default:
        console.log("Unknown action:", actionId, data);
    }
  };

  return (
    <div className="h-screen p-4 bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
      {/* Form Renderer */}
      <ComponentRenderer
        config={screen_102_add_vehicle}
        formData={formData}
        onFormDataChange={handleFormDataChange}
        onActionTrigger={handleActionTrigger}
      />
    </div>
  );
};
